import { ClientItemId } from 'owa-client-ids';
import getConversationSortByProperty from 'owa-mail-triage-table-utils/lib/getConversationSortByProperty';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
import { lazyFindConversationEqualToConversationId } from 'owa-mail-find-rows';
import { lazyLoadConversation, lazyLoadItem } from 'owa-mail-store-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { trace } from 'owa-trace';
import {
    getBaseFolderId,
    MailListRowDataType,
    TableView,
    MailFolderTableQuery,
} from 'owa-mail-list-store';

export default async function getNudgedRowData(
    rowId: string,
    tableView: TableView
): Promise<MailListRowDataType> {
    const tableQuery = tableView.tableQuery;
    if (tableQuery.listViewType === ReactListViewType.Message) {
        const clientItemId: ClientItemId = {
            Id: rowId,
            mailboxInfo: getMailboxInfoFromTableQuery(tableQuery),
        };

        return lazyLoadItem.importAndExecute(clientItemId, 'LoadNudgedItem');
    }

    return loadNudgedConversation(rowId, tableView);
}

async function loadNudgedConversation(
    conversationIdString: string,
    tableView: TableView
): Promise<MailListRowDataType> {
    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;
    const mailboxInfo = getMailboxInfoFromTableQuery(mailTableQuery);

    // retrieve the list view conversation data for the nudged conversation
    return lazyFindConversationEqualToConversationId
        .importAndExecute(
            getBaseFolderId(mailTableQuery),
            conversationIdString,
            getConversationSortByProperty(mailTableQuery),
            mailTableQuery.requestShapeName,
            mailboxInfo.requestOptions
        )
        .then(responseMessage => {
            if (responseMessage.ResponseClass == 'Success') {
                const conversations: MailListRowDataType[] = responseMessage.Conversations;
                if (
                    conversations &&
                    conversations.length > 0 &&
                    conversations[0].ConversationId.Id === conversationIdString
                ) {
                    const conversationId: ClientItemId = {
                        Id: conversationIdString,
                        mailboxInfo: mailboxInfo,
                    };

                    // prefetch the reading pane data for this conversation
                    lazyLoadConversation.importAndExecute(conversationId, 'LoadNudgedConversation');

                    return conversations[0];
                }
            }

            return null;
        })
        .catch(error => {
            trace.warn('loadNudgedConversation throws an exception' + error.message);
            return null;
        });
}
